import React, { useState, useEffect, useCallback } from 'react';
import { axios, useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(v||0);

const PAKETLER = ['TYT Hazırlık','AYT Sayısal','AYT Sözel','AYT Eşit Ağırlık','LGS','KPSS','YDS','Tüm Paket'];

const escapeHtml = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const formatDate = (date) => date ? new Date(date).toLocaleDateString('tr-TR') : '-';

const addMonths = (date, months) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
};

const buildInstallmentPlan = (form) => {
  const count = form.odeme_tipi === 'pesin' ? 1 : Math.max(1, parseInt(form.taksit_sayisi, 10) || 1);
  const total = parseFloat(form.net_ucret) || 0;
  const base = Math.floor((total / count) * 100) / 100;
  const rows = [];
  let used = 0;
  for (let i = 0; i < count; i += 1) {
    const amount = i === count - 1 ? Math.max(0, total - used) : base;
    used += amount;
    rows.push({
      no: i + 1,
      date: addMonths(form.ilk_odeme_tarihi || form.baslangic_tarihi, i),
      amount
    });
  }
  return rows;
};

const printCourseContract = ({ form, student, representativeName }) => {
  const installments = buildInstallmentPlan(form);
  const parentName = [student?.veli_ad, student?.veli_soyad].filter(Boolean).join(' ') || student?.veli_adi || '-';
  const discount = Math.max(0, (parseFloat(form.brut_ucret) || 0) - (parseFloat(form.net_ucret) || 0));
  const printWin = window.open('', '_blank', 'width=900,height=1000');
  if (!printWin) {
    toast.error('Sözleşme penceresi açılamadı. Tarayıcı popup iznini kontrol edin.');
    return;
  }

  const infoRows = [
    ['Öğrenci Adı Soyadı', `${student?.ad || ''} ${student?.soyad || ''}`],
    ['Öğrenci No / Sınıf', `${student?.ogrenci_no || '-'} / ${student?.sinif_adi || '-'}`],
    ['Öğrenci Telefon', student?.telefon || '-'],
    ['Veli Adı Soyadı', parentName],
    ['Veli Telefon', student?.veli_telefon || '-'],
    ['E-posta', student?.email || '-'],
    ['Adres', student?.adres || '-'],
    ['Eğitim Yılı', form.egitim_yili],
  ];

  const installmentRows = installments.map(row => `
    <tr>
      <td>${row.no}</td>
      <td>${formatDate(row.date)}</td>
      <td class="right">${TL(row.amount)}</td>
      <td></td>
    </tr>
  `).join('');

  printWin.document.write(`<!doctype html>
    <html lang="tr">
      <head>
        <meta charset="utf-8" />
        <title>Kurs Sözleşmesi - ${escapeHtml(student?.ad)} ${escapeHtml(student?.soyad)}</title>
        <style>
          * { box-sizing: border-box; }
          body { margin: 0; padding: 22px; background: #f8fafc; color: #111827; font-family: Arial, sans-serif; }
          .page { max-width: 820px; margin: 0 auto; background: #fff; border: 1px solid #d1d5db; padding: 24px 28px; }
          .top { text-align: center; border-bottom: 2px solid #111827; padding-bottom: 12px; margin-bottom: 14px; }
          .brand { font-size: 20px; font-weight: 900; }
          .muted { color: #6b7280; font-size: 11px; line-height: 1.5; }
          h1 { font-size: 22px; margin: 12px 0 0; letter-spacing: 0; }
          h2 { font-size: 14px; margin: 16px 0 8px; padding: 7px 9px; background: #f3f4f6; border: 1px solid #e5e7eb; }
          .grid { display: grid; grid-template-columns: 1fr 1fr; border-top: 1px solid #e5e7eb; border-left: 1px solid #e5e7eb; }
          .cell { display: grid; grid-template-columns: 150px 1fr; border-right: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb; min-height: 34px; }
          .label { background: #f9fafb; padding: 8px; font-size: 11px; font-weight: 800; color: #374151; }
          .value { padding: 8px; font-size: 12px; font-weight: 700; }
          .summary { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 8px; }
          .box { border: 1px solid #e5e7eb; padding: 9px; min-height: 58px; }
          .box .label { background: none; padding: 0 0 4px; display: block; }
          .box strong { font-size: 14px; }
          table { width: 100%; border-collapse: collapse; font-size: 12px; }
          th, td { border: 1px solid #e5e7eb; padding: 8px; text-align: left; }
          th { background: #f3f4f6; }
          .right { text-align: right; }
          .terms { font-size: 11.5px; line-height: 1.45; margin: 0; padding-left: 18px; }
          .terms li { margin-bottom: 5px; }
          .note { border: 1px solid #e5e7eb; padding: 10px; min-height: 46px; font-size: 12px; }
          .signatures { display: grid; grid-template-columns: 1fr 1fr; gap: 44px; margin-top: 44px; }
          .signature { border-top: 1px solid #111827; padding-top: 8px; text-align: center; font-size: 12px; min-height: 56px; }
          .date { margin-top: 18px; font-size: 12px; font-weight: 700; }
          .actions { max-width: 820px; margin: 12px auto 0; display: flex; justify-content: flex-end; }
          button { border: 0; background: #ef334e; color: #fff; border-radius: 8px; padding: 10px 18px; font-weight: 800; cursor: pointer; }
          @media print {
            body { background: #fff; padding: 0; }
            .page { border: 0; max-width: none; min-height: 100vh; }
            .actions { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="page">
          <div class="top">
            <div class="brand">ASDER Sistem Dershane</div>
            <div class="muted">Yönetim Paneli üzerinden oluşturulmuş kurs hizmet sözleşmesi</div>
            <h1>KURS SÖZLEŞMESİ</h1>
          </div>

          <h2>Taraf ve Öğrenci Bilgileri</h2>
          <div class="grid">
            ${infoRows.map(([label, value]) => `
              <div class="cell">
                <div class="label">${escapeHtml(label)}</div>
                <div class="value">${escapeHtml(value)}</div>
              </div>
            `).join('')}
          </div>

          <h2>Kurs ve Ücret Bilgileri</h2>
          <div class="summary">
            <div class="box"><span class="label">Kurs Konusu</span><strong>${escapeHtml(form.paket)}</strong></div>
            <div class="box"><span class="label">Başlangıç</span><strong>${formatDate(form.baslangic_tarihi)}</strong></div>
            <div class="box"><span class="label">Bitiş</span><strong>${formatDate(form.bitis_tarihi)}</strong></div>
            <div class="box"><span class="label">Ödeme Tipi</span><strong>${escapeHtml(form.odeme_tipi)}</strong></div>
            <div class="box"><span class="label">Brüt Ücret</span><strong>${TL(form.brut_ucret)}</strong></div>
            <div class="box"><span class="label">İndirim</span><strong>${TL(discount)}</strong></div>
            <div class="box"><span class="label">Net Ücret</span><strong>${TL(form.net_ucret)}</strong></div>
            <div class="box"><span class="label">Taksit Sayısı</span><strong>${installments.length}</strong></div>
          </div>

          <h2>Ödeme Planı</h2>
          <table>
            <thead><tr><th>Taksit</th><th>Ödeme Tarihi</th><th class="right">Tutar</th><th>Ödeme/İmza</th></tr></thead>
            <tbody>${installmentRows}</tbody>
          </table>

          <h2>Sözleşme Hükümleri</h2>
          <ol class="terms">
            <li>Veli/kursiyer, bu sözleşmede belirtilen eğitim hizmetini, tarihleri, toplam bedeli ve ödeme planını okuyup kabul ettiğini beyan eder.</li>
            <li>Kurum, belirtilen eğitim programını makul planlama içinde yürütmeyi; öğrenci ise ders, yoklama, ödev ve kurum kurallarına uymayı kabul eder.</li>
            <li>Ödemeler ödeme planında belirtilen tarihlerde yapılır. Gecikme halinde kurum, yasal hakları saklı kalmak üzere veli/kursiyer ile iletişime geçebilir.</li>
            <li>Erken ödeme yapılabilir; erken ödeme, kalan hizmet yükümlülüğünü ortadan kaldırmaz ve ödeme makbuzu ile kayıt altına alınır.</li>
            <li>Kayıt iptali, dondurma, iade veya ayrılma talepleri yürürlükteki mevzuat ve kurumun yazılı kayıtları esas alınarak değerlendirilir.</li>
            <li>Öğrencinin devam durumu, ders akışı ve sınav/ölçme süreçleri kurum kayıtlarında takip edilir. Veli, iletişim bilgilerindeki değişiklikleri kuruma bildirmekle yükümlüdür.</li>
            <li>Taraflar, kişisel verilerin eğitim, muhasebe, iletişim ve yasal yükümlülüklerin yerine getirilmesi amacıyla işlenebileceğini kabul eder.</li>
            <li>Bu belge iki nüsha düzenlenmiş olup taraflarca imzalandığında geçerlilik kazanır. Uyuşmazlıklarda kurum kayıtları ve ilgili yasal mevzuat dikkate alınır.</li>
          </ol>

          <h2>Notlar</h2>
          <div class="note">${escapeHtml(form.notlar || 'Ek not bulunmuyor.')}</div>

          <div class="date">Başvuru / Sözleşme Tarihi: ${formatDate(new Date())}</div>
          <div class="signatures">
            <div class="signature">
              Veli / Kursiyer<br />
              ${escapeHtml(parentName)}
            </div>
            <div class="signature">
              Kurum Yetkilisi<br />
              ${escapeHtml(representativeName || 'ASDER Sistem')}
            </div>
          </div>
        </div>
        <div class="actions"><button onclick="window.print()">Sözleşmeyi Yazdır</button></div>
      </body>
    </html>`);
  printWin.document.close();
  setTimeout(() => printWin.print(), 500);
};

// ── Modal: Yeni Sözleşme ───────────────────────────────────────── 
function SozlesmeModal({ ogrenciler, sablonlar, onSave, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSinif, setSelectedSinif] = useState('');
  const [form, setForm] = useState({
    ogrenci_id:'', egitim_yili: new Date().getFullYear()+'-'+(new Date().getFullYear()+1),
    paket:'TYT Hazırlık', egitim_turu:'TYT',
    baslangic_tarihi: new Date().toISOString().slice(0,10),
    bitis_tarihi: new Date(new Date().setMonth(new Date().getMonth()+9)).toISOString().slice(0,10),
    brut_ucret:'', sablon_id:'', indirim_tipi:'', indirim_tutar:'0', indirim_yuzde:'0',
    net_ucret:'', odeme_tipi:'taksit', taksit_sayisi:'9',
    ilk_odeme_tarihi: new Date().toISOString().slice(0,10), notlar:'',
  });
  const [saving, setSaving] = useState(false);

  // --- Yardımcı Fonksiyonlar ---
  const hesaplaNet = (brut, indirimT, indirimY) => {
    const b  = parseFloat(brut) || 0;
    const it = parseFloat(indirimT) || 0;
    const iy = parseFloat(indirimY) || 0;
    const ind = it > 0 ? it : (b * iy / 100);
    return Math.max(0, b - ind);
  };

  const handleChange = (field, val) => {
    setForm(f => {
      const nf = { ...f, [field]: val };
      if (['brut_ucret','indirim_tutar','indirim_yuzde'].includes(field)) {
        nf.net_ucret = hesaplaNet(nf.brut_ucret, nf.indirim_tutar, nf.indirim_yuzde).toFixed(2);
      }
      return nf;
    });
  };

  const handleSablonChange = (sablonId) => {
    if (!sablonId) {
      setForm(f => ({ ...f, sablon_id:'', indirim_tipi:'', indirim_tutar:'0', indirim_yuzde:'0',
        net_ucret: (parseFloat(f.brut_ucret)||0).toFixed(2) }));
      return;
    }
    const sablon = sablonlar.find(s => String(s.id) === sablonId);
    if (!sablon) return;
    const brut = parseFloat(form.brut_ucret) || 0;
    const yuzde = parseFloat(sablon.yuzde) || 0;
    const sabit = parseFloat(sablon.sabit_tutar) || 0;
    const indirimTutar = yuzde > 0 ? 0 : sabit;
    const indirimYuzde = yuzde > 0 ? yuzde : 0;
    const net = Math.max(0, brut - (yuzde > 0 ? brut * yuzde / 100 : sabit));
    setForm(f => ({
      ...f,
      sablon_id:     sablonId,
      indirim_tipi:  sablon.tip,
      indirim_tutar: indirimTutar.toFixed(2),
      indirim_yuzde: indirimYuzde.toFixed(2),
      net_ucret:     net.toFixed(2),
    }));
  };

  const handleSubmit = async () => {
    if (!form.ogrenci_id || !form.brut_ucret || !form.net_ucret) {
      toast.error('Zorunlu alanları doldurun'); return;
    }
    setSaving(true);
    try { await onSave(form); } finally { setSaving(false); }
  };

  const secilenSablon = sablonlar.find(s => String(s.id) === form.sablon_id);
  const benzersizSiniflar = [...new Set(ogrenciler.map(o => o.sinif_adi).filter(Boolean))];
  const filtreliOgrenciler = ogrenciler.filter(o => {
    const fullText = `${o.ad} ${o.soyad}`.toLowerCase();
    return fullText.includes(searchTerm.toLowerCase()) &&
      (selectedSinif === '' || o.sinif_adi === selectedSinif);
  });

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 740 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">📋 Yeni Sözleşme</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="muh-grid-2">
          
          {/* Öğrenci Seçimi ve Filtreleme Bölümü */}
          <div className="form-group" style={{ gridColumn: '1/-1', background: 'var(--bg-elevated)', padding: '15px', borderRadius: '12px', border: '1px solid var(--border)' }}>
            <label className="form-label" style={{ fontWeight: 800, color: 'var(--blue)', marginBottom: '10px', display: 'block' }}>
              Öğrenci Seçimi *
            </label>
            
            <div className="muh-filter-row" style={{ marginBottom: 10 }}>
              <div style={{ flex: 2 }}>
                <input 
                  className="form-input" 
                  placeholder="🔍 İsme göre öğrenci ara..." 
                  value={searchTerm} 
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <select 
                  className="form-input" 
                  value={selectedSinif} 
                  onChange={e => setSelectedSinif(e.target.value)}
                >
                  <option value="">Tüm Sınıflar</option>
                  {benzersizSiniflar.map(s => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', fontWeight: 700 }}>
                Listeden öğrenci seçin
              </div>
              <div style={{ fontSize: '0.72rem', color: 'var(--blue)', fontWeight: 800 }}>
                {filtreliOgrenciler.length} sonuç
              </div>
            </div>
            <select
              className="form-input"
              size={Math.min(7, Math.max(filtreliOgrenciler.length, 4))}
              value={form.ogrenci_id}
              onChange={e => handleChange('ogrenci_id', e.target.value)}
              style={{ height: 'auto', padding: '6px', background: '#fff', border: '1.5px solid var(--border)' }}
            >
              {filtreliOgrenciler.length === 0 ? (
                <option value="" disabled>Sonuç bulunamadı</option>
              ) : (
                filtreliOgrenciler.map(o => (
                  <option key={o.id} value={o.id}>
                    {o.ad} {o.soyad} | {o.sinif_adi || 'Sınıf Yok'} | No: {o.ogrenci_no || '-'}
                  </option>
                ))
              )}
            </select>
            {form.ogrenci_id && (
              <div style={{ marginTop: 8, fontSize: '0.82rem', color: '#10B981', fontWeight: 700 }}>
                ✅ Seçili: {ogrenciler.find(o => String(o.id) === String(form.ogrenci_id))?.ad} {ogrenciler.find(o => String(o.id) === String(form.ogrenci_id))?.soyad}
              </div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Eğitim Yılı</label>
            <input className="form-input" value={form.egitim_yili} onChange={e => handleChange('egitim_yili', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Paket</label>
            <select className="form-input" value={form.paket} onChange={e => handleChange('paket', e.target.value)}>
              {PAKETLER.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Başlangıç</label>
            <input className="form-input" type="date" value={form.baslangic_tarihi} onChange={e => handleChange('baslangic_tarihi', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Bitiş</label>
            <input className="form-input" type="date" value={form.bitis_tarihi} onChange={e => handleChange('bitis_tarihi', e.target.value)} />
          </div>

          <div className="form-group">
            <label className="form-label">Brüt Ücret (₺) *</label>
            <input className="form-input" type="number" value={form.brut_ucret}
              onChange={e => handleChange('brut_ucret', e.target.value)} placeholder="0" />
          </div>

          <div className="form-group">
            <label className="form-label">İndirim Şablonu</label>
            <select className="form-input" value={form.sablon_id}
              onChange={e => handleSablonChange(e.target.value)}>
              <option value="">— Şablon seçin (opsiyonel) —</option>
              {sablonlar.map(s => (
                <option key={s.id} value={s.id}>
                  {s.ad} {parseFloat(s.yuzde) > 0 ? `(%${s.yuzde})` : parseFloat(s.sabit_tutar) > 0 ? `(${TL(s.sabit_tutar)})` : ''}
                </option>
              ))}
            </select>
          </div>

          {secilenSablon && (
            <div style={{ gridColumn:'1/-1', padding:'10px 14px', borderRadius:10,
              background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.3)',
              display:'flex', alignItems:'center', gap:12 }}>
              <span style={{ fontSize:'1.3rem' }}>✅</span>
              <div>
                <div style={{ fontWeight:700, fontSize:'0.875rem', color:'#065F46' }}>
                  {secilenSablon.ad} uygulandı
                </div>
                <div style={{ fontSize:'0.78rem', color:'#065F46' }}>
                  {parseFloat(secilenSablon.yuzde)>0
                    ? `%${secilenSablon.yuzde} indirim → ${TL((parseFloat(form.brut_ucret)||0)*parseFloat(secilenSablon.yuzde)/100)} indirim`
                    : `${TL(secilenSablon.sabit_tutar)} sabit indirim`}
                </div>
              </div>
              <button style={{ marginLeft:'auto', background:'none', border:'none', cursor:'pointer', color:'#065F46', fontSize:'1rem' }}
                onClick={() => handleSablonChange('')}>✕</button>
            </div>
          )}

          {!form.sablon_id && (
            <>
              <div className="form-group">
                <label className="form-label">İndirim Tutarı (₺)</label>
                <input className="form-input" type="number" value={form.indirim_tutar}
                  onChange={e => handleChange('indirim_tutar', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">İndirim % (veya tutar kullan)</label>
                <input className="form-input" type="number" value={form.indirim_yuzde}
                  onChange={e => handleChange('indirim_yuzde', e.target.value)} />
              </div>
            </>
          )}

          <div className="form-group" style={{ gridColumn:'1/-1' }}>
            <label className="form-label">Net Ücret (₺) *</label>
            <div style={{ position:'relative' }}>
              <input className="form-input" type="number" value={form.net_ucret}
                onChange={e => handleChange('net_ucret', e.target.value)}
                style={{ fontWeight:800, fontSize:'1.15rem', color:'var(--blue)', paddingRight:120 }} />
              {parseFloat(form.brut_ucret) > 0 && parseFloat(form.brut_ucret) !== parseFloat(form.net_ucret) && (
                <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                  fontSize:'0.75rem', color:'#EF4444', fontWeight:700 }}>
                  -{TL(parseFloat(form.brut_ucret) - parseFloat(form.net_ucret))} indirim
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Ödeme Tipi</label>
            <select className="form-input" value={form.odeme_tipi} onChange={e => handleChange('odeme_tipi', e.target.value)}>
              <option value="pesin">Peşin</option>
              <option value="taksit">Taksit</option>
              <option value="kredi_karti">Kredi Kartı</option>
              <option value="senet">Senet</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Taksit Sayısı</label>
            <input className="form-input" type="number" min="1" max="24" value={form.taksit_sayisi}
              onChange={e => handleChange('taksit_sayisi', e.target.value)}
              disabled={form.odeme_tipi === 'pesin'} />
          </div>

          <div className="form-group">
            <label className="form-label">İlk Taksit Tarihi</label>
            <input className="form-input" type="date" value={form.ilk_odeme_tarihi}
              onChange={e => handleChange('ilk_odeme_tarihi', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Aylık Taksit Tutarı (~)</label>
            <div style={{ padding:'10px 14px', background:'var(--bg-elevated)', borderRadius:10,
              fontWeight:800, color:'#10B981', fontFamily:'var(--font-ui)' }}>
              {TL((parseFloat(form.net_ucret)||0) / (parseInt(form.taksit_sayisi)||1))}
            </div>
          </div>

          <div className="form-group" style={{ gridColumn:'1/-1' }}>
            <label className="form-label">Notlar</label>
            <textarea className="form-input" rows={2} value={form.notlar}
              onChange={e => handleChange('notlar', e.target.value)} />
          </div>
        </div>

        <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:16 }}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <><div className="spinner" style={{width:16,height:16}} /> Kaydediliyor...</> : '💾 Sözleşme Oluştur'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Modal: Tahsilat ──────────────────────────────────────────────
function TahsilatModal({ taksit, onSave, onClose }) {
  const [form, setForm] = useState({
    tutar: taksit?.tutar || '',
    odeme_yontemi: 'nakit',
    odeme_tarihi: new Date().toISOString().slice(0,10),
    makbuz_no: '', notlar: '',
  });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async () => {
    setSaving(true);
    try { await onSave({ ...form, taksit_id: taksit.id }); }
    finally { setSaving(false); }
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">💳 Tahsilat Al</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div style={{ background:'var(--bg-elevated)', borderRadius:12, padding:'12px 16px', marginBottom:16 }}>
          <div style={{ fontWeight:700 }}>{taksit.ad} {taksit.soyad} — Taksit #{taksit.taksit_no}</div>
          <div style={{ fontSize:'0.82rem', color:'var(--text-muted)' }}>
            Vade: {new Date(taksit.vade_tarihi).toLocaleDateString('tr-TR')} · {TL(taksit.tutar)}
          </div>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div className="form-group"><label className="form-label">Tahsil Tutarı (₺) *</label>
            <input className="form-input" type="number" value={form.tutar} onChange={e => setForm(f=>({...f,tutar:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Ödeme Yöntemi</label>
            <select className="form-input" value={form.odeme_yontemi} onChange={e => setForm(f=>({...f,odeme_yontemi:e.target.value}))}>
              <option value="nakit">Nakit</option>
              <option value="kredi_karti">Kredi Kartı</option>
              <option value="banka_havalesi">Banka Havalesi</option>
              <option value="pos">POS</option>
            </select></div>
          <div className="form-group"><label className="form-label">Ödeme Tarihi</label>
            <input className="form-input" type="date" value={form.odeme_tarihi} onChange={e => setForm(f=>({...f,odeme_tarihi:e.target.value}))} /></div>
          <div className="form-group"><label className="form-label">Makbuz / Fiş No</label>
            <input className="form-input" value={form.makbuz_no} onChange={e => setForm(f=>({...f,makbuz_no:e.target.value}))} /></div>
        </div>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:16 }}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            {saving ? <><div className="spinner" style={{width:16,height:16}} /> Kaydediliyor...</> : '✅ Tahsilatı Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Ana Sayfa ────────────────────────────────────────────────────
export default function SozlesmelerPage() {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 900 : false);
  const [sozlesmeler, setSozlesmeler] = useState([]);
  const [ogrenciler, setOgrenciler]   = useState([]);
  const [sablonlar, setSablonlar]     = useState([]);
  const [loading, setLoading]         = useState(true);
  const [total, setTotal]             = useState(0);
  const [filtre, setFiltre]           = useState({ durum:'', sayfa:1 });
  const [showModal, setShowModal]     = useState(false);
  const [secili, setSecili]           = useState(null);
  const [detay, setDetay]             = useState(null);
  const [tahsilatTaksit, setTahsilatTaksit] = useState(null);

  // Toplu işlem seçimi
  const [selectedIds, setSelectedIds] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ ...filtre });
      const r = await axios.get(`/muhasebe/sozlesmeler?${params}`);
      if (r.data.success) { 
        setSozlesmeler(r.data.data); 
        setTotal(r.data.total);
        setSelectedIds([]); // Filtre değişince seçimleri temizle
      }
    } catch {} finally { setLoading(false); }
  }, [filtre]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    axios.get('/ogrenciler').then(r => { if (r.data.success) setOgrenciler(r.data.data || []); }).catch(()=>{});
    axios.get('/muhasebe/indirim-sablonlari').then(r => { if (r.data.success) setSablonlar(r.data.data || []); }).catch(()=>{});
  }, []);

  const handleDetay = async (id) => {
    setSecili(id);
    try {
      const r = await axios.get(`/muhasebe/sozlesmeler/${id}`);
      if (r.data.success) setDetay(r.data.data);
    } catch {}
  };

  const handleSave = async (form) => {
    try {
      await axios.post('/muhasebe/sozlesmeler', form);
      toast.success('Sözleşme oluşturuldu!');
      const student = ogrenciler.find(o => String(o.id) === String(form.ogrenci_id));
      printCourseContract({
        form,
        student,
        representativeName: [user?.ad, user?.soyad].filter(Boolean).join(' ')
      });
      setShowModal(false); load();
    } catch (e) {
      toast.error(e.response?.data?.message || 'Hata');
      throw e;
    }
  };

  // ── TEKLİ VE TOPLU İŞLEM FONKSİYONLARI ──────────────────────────
  
  const handleDelete = async (id) => {
    if(!window.confirm("Bu sözleşmeyi tamamen silmek istediğinize emin misiniz? Bu işlem geri alınamaz.")) return;
    try {
      await axios.delete(`/muhasebe/sozlesmeler/${id}`);
      toast.success('Sözleşme silindi');
      if(secili === id) setSecili(null);
      load();
    } catch (e) { toast.error('Silme işlemi başarısız'); }
  };

  const handleStatusUpdate = async (id, newDurum) => {
    try {
      await axios.put(`/muhasebe/sozlesmeler/${id}`, { durum: newDurum });
      toast.success(`Durum güncellendi: ${newDurum}`);
      if (secili === id) handleDetay(id);
      load();
    } catch (e) { toast.error('Güncelleme başarısız'); }
  };

  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const toggleSelectAll = () => {
    if (selectedIds.length === sozlesmeler.length) setSelectedIds([]);
    else setSelectedIds(sozlesmeler.map(s => s.id));
  };

  const handleBulkDelete = async () => {
    if(!window.confirm(`${selectedIds.length} adet sözleşmeyi SİLMEK istediğinize emin misiniz?`)) return;
    try {
      await axios.post('/muhasebe/sozlesmeler/bulk-delete', { ids: selectedIds });
      toast.success('Seçili kayıtlar silindi');
      load();
    } catch { toast.error('Toplu silme başarısız'); }
  };

  const handleBulkStatus = async (newDurum) => {
    if(!window.confirm(`${selectedIds.length} adet sözleşmeyi '${newDurum}' durumuna getirmek istiyor musunuz?`)) return;
    try {
      await axios.post('/muhasebe/sozlesmeler/bulk-status', { ids: selectedIds, durum: newDurum });
      toast.success('Seçili kayıtlar güncellendi');
      load();
    } catch { toast.error('Toplu güncelleme başarısız'); }
  };

  const handleTahsilat = async (form) => {
    try {
      await axios.post('/muhasebe/tahsilat', form);
      toast.success('Tahsilat kaydedildi!');
      setTahsilatTaksit(null);
      if (secili) handleDetay(secili);
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const DURUM_RENK = { aktif:'#10B981', iptal:'#EF4444', tamamlandi:'#3B82F6', donduruldu:'#F59E0B' };
  const DURUM_ETIKET = { aktif:'Aktif', iptal:'İptal', tamamlandi:'Tamamlandı', donduruldu:'Donduruldu' };
  const TAKSIT_RENK = { odendi:'#10B981', bekliyor:'#3B82F6', gecikti:'#EF4444', iptal:'#94A3B8' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily:'var(--font-ui)', fontWeight:900 }}>📋 Sözleşmeler</h2>
          <div className="section-subtitle">{total} toplam sözleşme</div>
        </div>
        
        <div className="muh-filter-row">
          {selectedIds.length > 0 && (
            <div className="bulk-actions-bar animate-fadeIn" style={{ display:'flex', gap:8, alignItems:'center', background:'var(--blue-dim)', padding:'4px 12px', borderRadius:12 }}>
              <span style={{ fontWeight:700, fontSize:'0.85rem', color:'var(--blue)' }}>{selectedIds.length} Seçili</span>
              <button className="btn btn-sm btn-outline" onClick={() => handleBulkStatus('aktif')}>Aktif</button>
              <button className="btn btn-sm btn-outline" onClick={() => handleBulkStatus('donduruldu')}>Dondur</button>
              <button className="btn btn-sm btn-outline" style={{ color:'#EF4444' }} onClick={handleBulkDelete}>Sil</button>
            </div>
          )}
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Yeni Sözleşme</button>
        </div>
      </div>

      <div className="card" style={{ padding:'12px 16px' }}>
        <div style={{ display:'flex', gap:8, overflowX:'auto', flexWrap:'nowrap', paddingBottom:2 }}>
          {['','aktif','tamamlandi','iptal','donduruldu'].map(d => (
            <button key={d} className={`chip ${filtre.durum===d?'active':''}`}
              style={{ flex:'0 0 auto' }}
              onClick={() => setFiltre(f => ({...f, durum:d, sayfa:1}))}>
              {d ? (DURUM_ETIKET[d] || d) : 'Tümü'}
            </button>
          ))}
        </div>
      </div>

      <div className={secili ? 'muh-two-col' : ''} style={{ display:'grid', gridTemplateColumns: secili ? '1.2fr 1fr' : '1fr', gap:16 }}>
        <div className="card animate-fadeInUp" style={{ padding:0 }}>
          {loading ? (
            <div className="page-loader" style={{ minHeight:200 }}><div className="spinner" /></div>
          ) : isMobile ? (
            <div style={{ padding: 12, display:'flex', flexDirection:'column', gap:10 }}>
              {sozlesmeler.length === 0 ? (
                <div className="empty-state" style={{ padding: 36 }}>
                  <h3>Kayıt bulunamadı</h3>
                </div>
              ) : sozlesmeler.map(s => (
                <div
                  key={s.id}
                  className="card"
                  onClick={() => handleDetay(s.id)}
                  style={{
                    cursor:'pointer',
                    padding: 12,
                    borderLeft: `4px solid ${DURUM_RENK[s.durum] || '#94A3B8'}`,
                    background: secili===s.id ? 'var(--blue-dim)' : 'var(--bg-card)',
                  }}
                >
                  <div style={{ display:'flex', justifyContent:'space-between', gap:10, alignItems:'flex-start' }}>
                    <label onClick={(e) => e.stopPropagation()} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                      <input type="checkbox" checked={selectedIds.includes(s.id)} onChange={() => toggleSelect(s.id)} />
                    </label>
                    <span className="badge" style={{ background:(DURUM_RENK[s.durum]||'#94A3B8')+'22', color:DURUM_RENK[s.durum]||'#94A3B8' }}>
                      {DURUM_ETIKET[s.durum] || s.durum}
                    </span>
                  </div>
                  <div style={{ fontWeight:800, marginTop: 6 }}>{s.ad} {s.soyad}</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--text-muted)', marginTop:2 }}>{s.sinif_adi} · {s.egitim_yili}</div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginTop:10 }}>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>Net</div>
                    <div style={{ fontWeight:800, color:'var(--blue)', textAlign:'right' }}>{TL(s.net_ucret)}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>Ödenen</div>
                    <div style={{ fontWeight:700, color:'#10B981', textAlign:'right' }}>{TL(s.odenen_tutar)}</div>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>Kalan</div>
                    <div style={{ fontWeight:700, color:s.kalan_tutar > 0 ? '#EF4444' : '#10B981', textAlign:'right' }}>{TL(s.kalan_tutar)}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: 40 }}><input type="checkbox" checked={selectedIds.length === sozlesmeler.length && sozlesmeler.length > 0} onChange={toggleSelectAll} /></th>
                    <th>Öğrenci</th><th>Paket</th><th>İndirim</th><th>Net Ücret</th><th>Ödenen</th><th>Kalan</th><th>Durum</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {sozlesmeler.map(s => (
                    <tr key={s.id} style={{ cursor:'pointer', background: secili===s.id ? 'var(--blue-dim)' : '' }}
                      onClick={() => handleDetay(s.id)}>
                      <td onClick={e => e.stopPropagation()}>
                        <input type="checkbox" checked={selectedIds.includes(s.id)} onChange={() => toggleSelect(s.id)} />
                      </td>
                      <td>
                        <div style={{ fontWeight:700 }}>{s.ad} {s.soyad}</div>
                        <div style={{ fontSize:'0.72rem', color:'var(--text-muted)' }}>{s.sinif_adi} · {s.egitim_yili}</div>
                      </td>
                      <td style={{ fontSize:'0.82rem' }}>{s.paket}</td>
                      <td>
                        <span style={{ fontSize:'0.78rem', color:'#10B981', fontWeight:700 }}>
                          {parseFloat(s.indirim_tutar) > 0 ? `-${TL(s.indirim_tutar)}` : '—'}
                        </span>
                      </td>
                      <td style={{ fontFamily:'var(--font-ui)', fontWeight:800, color:'var(--blue)' }}>{TL(s.net_ucret)}</td>
                      <td style={{ color:'#10B981', fontWeight:700 }}>{TL(s.odenen_tutar)}</td>
                      <td style={{ color: s.kalan_tutar > 0 ? '#EF4444' : '#10B981', fontWeight:700 }}>{TL(s.kalan_tutar)}</td>
                      <td>
                        <span className="badge" style={{ background:(DURUM_RENK[s.durum]||'#94A3B8')+'22', color:DURUM_RENK[s.durum]||'#94A3B8' }}>
                          {DURUM_ETIKET[s.durum] || s.durum}
                        </span>
                      </td>
                      <td><button className="btn btn-outline btn-sm">Detay</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {secili && detay && (
          <div className="card animate-fadeInUp" style={{ padding:0 }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
              <div>
                <div style={{ fontFamily:'var(--font-ui)', fontWeight:800 }}>{detay.ad} {detay.soyad}</div>
                <div style={{ fontSize:'0.78rem', color:'var(--text-muted)' }}>{detay.paket} · {detay.egitim_yili}</div>
                
                <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                   <select 
                    className="form-input" 
                    style={{ height: 28, fontSize: '0.75rem', width: 'auto', padding: '0 8px' }}
                    value={detay.durum}
                    onChange={(e) => handleStatusUpdate(detay.id, e.target.value)}
                   >
                     <option value="aktif">Aktif Yap</option>
                     <option value="donduruldu">Dondur</option>
                     <option value="iptal">İptal Et</option>
                     <option value="tamamlandi">Tamamlandı</option>
                   </select>
                   <button 
                    className="btn btn-sm" 
                    style={{ background: '#EF4444', color: 'white', border: 'none', height: 28 }}
                    onClick={() => handleDelete(detay.id)}
                   >
                     Sil
                   </button>
                </div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={() => setSecili(null)}>✕</button>
            </div>

            <div className="muh-grid-4" style={{ padding:'12px 16px', gap:8, borderBottom:'1px solid var(--border)' }}>
              {[
                { l:'Brüt', v:TL(detay.brut_ucret), c:'var(--text-secondary)' },
                { l:'İndirim', v:TL(detay.indirim_tutar), c:'#10B981' },
                { l:'Net', v:TL(detay.net_ucret), c:'var(--blue)' },
                { l:'Kalan', v:TL(detay.taksitler?.filter(t=>t.durum!=='odendi'&&t.durum!=='iptal').reduce((s,t)=>s+parseFloat(t.tutar),0)), c:'#EF4444' },
              ].map((i,k) => (
                <div key={k} style={{ textAlign:'center', padding:'10px', background:'var(--bg-elevated)', borderRadius:10 }}>
                  <div style={{ fontFamily:'var(--font-ui)', fontWeight:900, fontSize: '0.85rem', color:i.c }}>{i.v}</div>
                  <div style={{ fontSize:'0.70rem', color:'var(--text-muted)' }}>{i.l}</div>
                </div>
              ))}
            </div>

            <div style={{ padding:'10px 16px', fontWeight:700, fontSize:'0.85rem', borderBottom:'1px solid var(--border)' }}>
              Taksit Planı
            </div>
            <div style={{ maxHeight:360, overflowY:'auto' }}>
              {(detay.taksitler || []).map((t, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 16px', borderBottom:'1px solid var(--border)' }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:'0.875rem' }}>#{t.taksit_no} — {TL(t.tutar)}</div>
                    <div style={{ fontSize:'0.72rem', color:'var(--text-muted)' }}>
                      {new Date(t.vade_tarihi).toLocaleDateString('tr-TR')}
                      {t.gercek_odeme && ` · Ödendi: ${new Date(t.gercek_odeme).toLocaleDateString('tr-TR')}`}
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                    <span className="badge" style={{ background:(TAKSIT_RENK[t.durum]||'#94A3B8')+'22', color:TAKSIT_RENK[t.durum]||'#94A3B8' }}>
                      {t.durum}
                    </span>
                    {(t.durum==='bekliyor'||t.durum==='gecikti') && (
                      <button className="btn btn-sm" style={{ background:'#10B981', color:'white', border:'none' }}
                        onClick={() => setTahsilatTaksit({...t, ad:detay.ad, soyad:detay.soyad})}>
                        💳 Al
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {showModal && <SozlesmeModal ogrenciler={ogrenciler} sablonlar={sablonlar} onSave={handleSave} onClose={() => setShowModal(false)} />}
      {tahsilatTaksit && <TahsilatModal taksit={tahsilatTaksit} onSave={handleTahsilat} onClose={() => setTahsilatTaksit(null)} />}
    </div>
  );
}
